import {Decoder, field, number, object} from 'json-bouncer'

export interface Vat {
    readonly percentage: number
    readonly price: number
}

export function vatDecoder(): Decoder<Vat> {
    return object({
        percentage: field('percentage', number()),
        price: field('price', number())
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/Vat.ts